import service from '../../../@services'
import { useState, useEffect, useRef, useContext } from 'react'
import ReactDom from 'react-dom'
import { ShowAddSheet } from '../context'

import AddCheckBill from '../components/AddCheckBill'

const getCheckNo = async () => {
  return await service.inventory.getCheckSheetNo()
}

export default function useAddCheckSheet(
  setShowAdd = () => {},
  getList,
  storeCode
) {
  const MountDom = useRef(document.createElement('div'))
  const [checkNo, setCheckNo] = useState('')
  // const { setShowAdd } = useContext(ShowAddSheet)
  const showAddCheckSheet = async $checkNo => {
    if ($checkNo) {
      setCheckNo($checkNo)
    } else {
      let _checkNo = await getCheckNo()
      setCheckNo(_checkNo)

      //   renderAddCheckBill(_checkNo)
    }
  }
  const close = () => {
    setShowAdd(false)
    setCheckNo(null)
    // ReactDom.unmountComponentAtNode(MountDom.current)
    // ReactDom.unmountComponentAtNode()
  }
  useEffect(() => {
    const container = document.getElementById('add-check-sheet-container')
    let _MountDom = MountDom.current
    container.appendChild(_MountDom)
    return () => {
      container.removeChild(_MountDom)
    }
  }, [])
  const renderAddCheckBill = () => {
    setShowAdd(true)
    ReactDom.render(
      <AddCheckSheetModal
        checkNo={checkNo}
        hide={close}
        getList={getList}
        storeCode={storeCode}
      />,
      MountDom.current
    )
  }
  useEffect(() => {
    let _MountDom = MountDom.current
    checkNo && renderAddCheckBill()
    return () => {
      ReactDom.unmountComponentAtNode(_MountDom)
    }
  }, [checkNo])
  return {
    showAddCheckSheet
  }
}

const AddCheckSheetModal = ({ checkNo, hide, getList, storeCode }) => {
  return (
    !!checkNo && (
      <AddCheckBill
        checkNo={checkNo}
        hide={hide}
        getList={getList}
        storeCode={storeCode}
      />
    )
  )
}
